import React from 'react'

function WaitlistButton(props) {
  return <button className="join-btn" onClick={props.waitlist}>{props.waitlistbtn_text ? props.waitlistbtn_text : "Join Waitlist Now!"}</button>
}

export default WaitlistButton
